<!-- ════════════ NAVBAR ════════════ -->
<nav class="unav">
  <div class="container-fluid">
    <a class="unav-brand" routerLink="/">
      <img src="assetses/img/logo.png" alt="UMYOBizDFW">
      <span>UMYO<em>BizDFW</em></span>
    </a>
    <button class="unav-tog" id="navTog" (click)="toggleNav()"><span></span><span></span><span></span></button>
    <ul class="unav-links" id="navLinks" [class.nav-open]="isNavOpen">
      <li><a href="/">Home</a></li>
      <li><a href="/about">About Us</a></li>
      <li><a routerLink="/networks">Network</a></li>
      <li><a routerLink="/hub">Hub</a></li>
      <li><a routerLink="/anti-bullying">Anti-Bullying</a></li>
      <li><a routerLink="/community-impact" class="active">Community Fund</a></li>
      <li><a routerLink="/empower-youth">Empower Youth</a></li>
      <li><a routerLink="/services">Type of Servcies</a></li>
      <li><a routerLink="/cf">Card Features</a></li>
    </ul>
    <!-- <a href="/#registration-form" class="unav-cta" >Join $2.54/mo</a> -->
  </div>
</nav>

<!-- ════════════════ HERO ════════════════ -->
<section class="uhero">
  <div class="cg"></div>
  <div class="orb orb1"></div>
  <div class="orb orb2"></div>
  <div class="container" style="position:relative;z-index:1;">
    <div class="row align-items-center gy-5">
      <div class="col-lg-7">
        <p class="hero-ey">DFW Members-Owned Expansion Fund</p>
        <h1 class="hero-t">
          Community<br><span class="ac">Impact Fund</span>
        </h1>
        <p class="hero-sub">What if a city decided to take care of its own? Not through charity. Not through politics. Not through waiting. But through unity. DFW becomes the national blueprint.</p>
        <div class="hero-btns">
          <a href="/#registration-form" class="btn-c">👉 Join the Movement</a>
          <a href="/community-impact#impact" class="btn-o">See the Impact</a>
        </div>
      </div>
      <div class="col-lg-5 d-none d-lg-flex justify-content-center">
        <div style="position:relative;text-align:center;">
          <div style="width:300px;height:300px;border-radius:50%;border:1px solid rgba(0,212,255,.12);display:flex;align-items:center;justify-content:center;position:relative;">
            <div style="position:absolute;inset:-2px;border-radius:50%;border:2px solid transparent;border-top-color:var(--cc);border-right-color:rgba(0,212,255,.3);animation:spin 5s linear infinite;"></div>
            <div style="width:240px;height:240px;border-radius:50%;background:radial-gradient(circle,rgba(0,87,255,.15),transparent 70%);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.5rem;">
              <div style="font-size:3.5rem;filter:drop-shadow(0 0 20px rgba(0,212,255,.5));">🏦</div>
              <div style="font-family:var(--fh);font-size:1.8rem;color:var(--cc);letter-spacing:.08em;">15%</div>
              <div style="font-size:.7rem;letter-spacing:.15em;text-transform:uppercase;color:var(--cm);">Back to Community</div>
            </div>
            <span style="position:absolute;top:20px;right:0;background:rgba(0,212,255,.1);border:1px solid rgba(0,212,255,.25);border-radius:50px;padding:.35rem .9rem;font-size:.72rem;font-weight:600;color:var(--ccl);letter-spacing:.08em;">$9M+/year</span>
            <span style="position:absolute;bottom:30px;right:-10px;background:rgba(0,212,255,.1);border:1px solid rgba(0,212,255,.25);border-radius:50px;padding:.35rem .9rem;font-size:.72rem;font-weight:600;color:var(--ccl);letter-spacing:.08em;">8.3M DFW</span>
            <span style="position:absolute;bottom:20px;left:0;background:rgba(0,212,255,.1);border:1px solid rgba(0,212,255,.25);border-radius:50px;padding:.35rem .9rem;font-size:.72rem;font-weight:600;color:var(--ccl);letter-spacing:.08em;">No Corp Control</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="scr">
    <span>Scroll to explore</span>
    <div class="scl"></div>
  </div>
</section>

<!-- ════════════════ STATS STRIP ════════════════ -->
<div class="umstrip " sipScrollReveal [sipDelay]="0">
  <div class="container">
    <div class="ums"><div class="ums-n">8.3M</div><div class="ums-l">DFW Residents</div></div>
    <div class="ums"><div class="ums-n">15%</div><div class="ums-l">Monthly Community Fund</div></div>
    <div class="ums"><div class="ums-n">$9M+</div><div class="ums-l">Annual Circulation Potential</div></div>
    <div class="ums"><div class="ums-n">100K</div><div class="ums-l">Business Target</div></div>
    <div class="ums"><div class="ums-n">$0</div><div class="ums-l">Outside Control</div></div>
  </div>
</div>

<!-- ════════════════ DECLARATION ════════════════ -->
<section class="usec">
  <div class="cg"></div>
  <div class="container" style="position:relative;z-index:1;">
    <div class="row g-5 align-items-center">
      <div class="col-lg-6 " sipScrollReveal [sipDelay]="0">
        <span class="lbl">A Community Declaration</span>
        <h2 class="hd2 mb-3">This Is Not<br><span class="ac">Charity.</span></h2>
        <div class="dv"></div>
        <p class="tx mb-3">This is <strong style="color:var(--cw);">structured reinvestment</strong>. The DFW Members-Owned Expansion Fund is more than a program — it is a declaration that community still matters.</p>
        <p class="tx mb-3">Every registration is a promise. A promise that when an elderly resident is struggling with an electric bill, the community steps in. When a family faces temporary hardship, the community responds.</p>
        <p class="tx">This is a storefront where <strong style="color:var(--cw);">community supports community</strong>. Local businesses partner directly. Residents circulate dollars locally. Support flows inward, not outward.</p>
      </div>
      <div class="col-lg-6 " sipScrollReveal [sipDelay]="0">
        <div class="qcard mb-4">
          <p>"We are not asking for rescue. We are building responsibility. We are building ownership. DFW becomes the example."</p>
        </div>
        <div class="row g-3">
          <div class="col-6">
            <div class="fund-pill"><span class="fi">🏠</span><div><strong>Mortgage</strong> Assistance</div></div>
          </div>
          <div class="col-6">
            <div class="fund-pill"><span class="fi">🚗</span><div><strong>Car Note</strong> Assistance</div></div>
          </div>
          <div class="col-6">
            <div class="fund-pill"><span class="fi">⛽</span><div><strong>Gas</strong> Cards</div></div>
          </div>
          <div class="col-6">
            <div class="fund-pill"><span class="fi">🛒</span><div><strong>Grocery</strong> Cards</div></div>
          </div>
          <div class="col-6">
            <div class="fund-pill"><span class="fi">⚡</span><div><strong>Electric Bill</strong> Assist</div></div>
          </div>
          <div class="col-6">
            <div class="fund-pill"><span class="fi">💼</span><div><strong>Business</strong> Giveaways</div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════════════ FUND ALLOCATION ════════════════ -->
<section class="usec usec-alt">
  <div class="container" style="position:relative;z-index:1;">
    <div class="text-center mb-5 " sipScrollReveal [sipDelay]="0">
      <span class="lbl">Fixed Allocation Model</span>
      <h2 class="hd2">How the <span class="ac">15% Is Distributed</span></h2>
      <div class="dv mx-auto"></div>
      <p class="tx mx-auto" style="max-width:580px;">Every month, the 15% Community Circulation Fund is distributed using this fixed percentage model — fully scalable, no manual balancing needed.</p>
    </div>
    <div class="row g-4 align-items-center">
      <div class="col-lg-6 " sipScrollReveal [sipDelay]="0">
        <div class="alloc-row">
          <div class="alloc-label"><span>🏠 Mortgage Assistance ($2,000 each)</span><span>40%</span></div>
          <div class="alloc-bar"><div class="alloc-fill" style="width:40%;"></div></div>
        </div>
        <div class="alloc-row">
          <div class="alloc-label"><span>🚗 Car Note Assistance ($500 each)</span><span>25%</span></div>
          <div class="alloc-bar"><div class="alloc-fill" style="width:25%;"></div></div>
        </div>
        <div class="alloc-row">
          <div class="alloc-label"><span>⛽ Gas Cards ($100 each)</span><span>15%</span></div>
          <div class="alloc-bar"><div class="alloc-fill" style="width:15%;"></div></div>
        </div>
        <div class="alloc-row">
          <div class="alloc-label"><span>⚡ Electricity Assistance ($200 each)</span><span>10%</span></div>
          <div class="alloc-bar"><div class="alloc-fill" style="width:10%;"></div></div>
        </div>
        <div class="alloc-row">
          <div class="alloc-label"><span>🛒 Grocery Cards ($150 each)</span><span>10%</span></div>
          <div class="alloc-bar"><div class="alloc-fill" style="width:10%;"></div></div>
        </div>
      </div>
      <div class="col-lg-6" sipScrollReveal [sipDelay]="0.08">
        <div style="background:rgba(0,212,255,.04);border:1px solid var(--bd);border-radius:14px;padding:2rem;">
          <span class="lbl">Why This Model Works</span>
          <div class="fund-pill mb-2"><span class="fi">✔</span> Fully scalable at any membership level</div>
          <div class="fund-pill mb-2"><span class="fi">✔</span> No manual balancing needed</div>
          <div class="fund-pill mb-2"><span class="fi">✔</span> Percentage-based stability</div>
          <div class="fund-pill mb-2"><span class="fi">✔</span> Built-in rollover buffer for reserves</div>
          <div class="fund-pill"><span class="fi">✔</span> Investor-clean and defensible</div>
          <div style="margin-top:1.5rem;padding:1rem;background:rgba(0,212,255,.07);border-radius:10px;border:1px solid rgba(0,212,255,.15);">
            <p style="font-size:.82rem;color:var(--cm);margin:0;font-style:italic;">Remaining funds roll into next month buffer — nothing is wasted, everything compounds.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════════════ BUSINESS IMPACT ════════════════ -->
<section class="usec" id="impact">
  <div class="cg"></div>
  <div class="container" style="position:relative;z-index:1;">
    <div class="text-center mb-5 " sipScrollReveal [sipDelay]="0">
      <span class="lbl">DFW Business Impact Partnership</span>
      <h2 class="hd2">Business <span class="ac">Participation</span><br>Changes Everything</h2>
      <div class="dv mx-auto"></div>
      <p class="tx mx-auto" style="max-width:600px;">At $49.99/month per business, here is the mathematical impact of community participation. The more businesses join, the more families are supported.</p>
    </div>

    <div class="row g-4">
      <!-- 35K -->
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.08">
        <div class="uc calc-card h-100">
          <div class="cc-top">📊 35,000 Businesses</div>
          <div class="cc-rev">$1.74M</div>
          <div class="cc-sub">Total Monthly Revenue</div>
          <div style="font-size:.78rem;color:var(--cm);margin-bottom:.8rem;">35,000 × $49.99 = $1,749,650</div>
          <div class="cc-fund">💰 $262,447/mo</div>
          <div style="font-size:.72rem;letter-spacing:.08em;text-transform:uppercase;color:var(--cm);margin-bottom:1rem;">15% Community Fund</div>
          <div class="cc-item">131 Mortgage Assists ($2,000 each)</div>
          <div class="cc-item">OR 524 Car Note Grants ($500 each)</div>
          <div class="cc-item">OR 2,624 Gas Cards ($100 each)</div>
          <div class="cc-item">OR 1,749 Grocery Cards ($150 each)</div>
          <div class="cc-item">OR 50 Residents Daily → $170+ Support</div>
        </div>
      </div>
      <!-- 50K -->
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.16">
        <div class="uc calc-card featured h-100" style="position:relative;">
          <div class="calc-badge">Most Impact</div>
          <div class="cc-top">📊 50,000 Businesses</div>
          <div class="cc-rev">$2.49M</div>
          <div class="cc-sub">Total Monthly Revenue</div>
          <div style="font-size:.78rem;color:var(--cm);margin-bottom:.8rem;">50,000 × $49.99 = $2,499,500</div>
          <div class="cc-fund">💰 $374,925/mo</div>
          <div style="font-size:.72rem;letter-spacing:.08em;text-transform:uppercase;color:var(--cm);margin-bottom:1rem;">15% Community Fund</div>
          <div class="cc-item">187 Mortgage Assists ($2,000 each)</div>
          <div class="cc-item">OR 749 Car Note Grants ($500 each)</div>
          <div class="cc-item">OR 3,749 Gas Cards ($100 each)</div>
          <div class="cc-item">OR 2,499 Grocery Cards ($150 each)</div>
          <div class="cc-item">OR 50 Residents Daily → $250+ Support</div>
        </div>
      </div>
      <!-- 100K -->
      <div class="col-md-4" sipScrollReveal [sipDelay]="0.24">
        <div class="uc calc-card h-100">
          <div class="cc-top">📊 100,000 Businesses</div>
          <div class="cc-rev">$4.99M</div>
          <div class="cc-sub">Total Monthly Revenue</div>
          <div style="font-size:.78rem;color:var(--cm);margin-bottom:.8rem;">100,000 × $49.99 = $4,999,000</div>
          <div class="cc-fund">💰 $749,850/mo</div>
          <div style="font-size:.72rem;letter-spacing:.08em;text-transform:uppercase;color:var(--cm);margin-bottom:1rem;">15% Community Fund</div>
          <div class="cc-item">374 Mortgage Assists ($2,000 each)</div>
          <div class="cc-item">OR 1,499 Car Note Grants ($500 each)</div>
          <div class="cc-item">OR 7,498 Gas Cards ($100 each)</div>
          <div class="cc-item">OR 4,999 Grocery Cards ($150 each)</div>
          <div class="cc-item">OR 50 Residents Daily → $500 Support</div>
        </div>
      </div>
    </div>

    <!-- Scale Unlocks -->
    <div class=" mt-4" sipScrollReveal [sipDelay]="0.32">
      <div style="background:rgba(0,212,255,.04);border:1px solid var(--bd);border-radius:14px;padding:1.8rem 2rem;">
        <span class="lbl">🔥 Scale Unlocks More Support</span>
        <div class="row g-3">
          <div class="col-md-4">
            <div style="text-align:center;padding:.8rem;background:rgba(0,212,255,.05);border-radius:10px;border:1px solid rgba(0,212,255,.1);">
              <div style="font-family:var(--fh);font-size:1.4rem;color:var(--cc);">35K Businesses</div>
              <div style="font-size:.82rem;color:var(--cm);margin-top:.3rem;">Choose <strong style="color:var(--cw);">1</strong> support category</div>
            </div>
          </div>
          <div class="col-md-4">
            <div style="text-align:center;padding:.8rem;background:rgba(0,212,255,.08);border-radius:10px;border:1px solid rgba(0,212,255,.2);">
              <div style="font-family:var(--fh);font-size:1.4rem;color:var(--cc);">70K Businesses</div>
              <div style="font-size:.82rem;color:var(--cm);margin-top:.3rem;">Choose <strong style="color:var(--cw);">2</strong> support categories</div>
            </div>
          </div>
          <div class="col-md-4">
            <div style="text-align:center;padding:.8rem;background:rgba(0,212,255,.05);border-radius:10px;border:1px solid rgba(0,212,255,.1);">
              <div style="font-family:var(--fh);font-size:1.4rem;color:var(--cc);">140K Businesses</div>
              <div style="font-size:.82rem;color:var(--cm);margin-top:.3rem;">Choose <strong style="color:var(--cw);">4</strong> support categories</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════════════ RESIDENT IMPACT ════════════════ -->
<section class="usec usec-alt">
  <div class="container">
    <div class="text-center mb-5 " sipScrollReveal [sipDelay]="0">
      <span class="lbl">DFW Residents Impact Partnership</span>
      <h2 class="hd2">Resident <span class="ac">Participation</span><br>Multiplies Power</h2>
      <div class="dv mx-auto"></div>
      <p class="tx mx-auto" style="max-width:600px;">See how resident membership at different price points creates real monthly distributions. Fixed allocation model — automatically scales at any count.</p>
    </div>

    <!-- 50K Residents -->
    <div class=" mb-3" sipScrollReveal [sipDelay]="0.08">
      <span class="lbl">👥 50,000 Residents</span>
    </div>
    <div class="row g-3 mb-5">
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.08">
        <div class="uc rtier h-100">
          <div class="rtier-head">$2.54/month</div>
          <div class="rtier-price">$19,050<span>/mo fund</span></div>
          <div class="rtier-fund">15% of $127,000 total</div>
          <div class="rtier-row"><span class="rk">🏠 Mortgage Assists</span><span class="rv2">3 families</span></div>
          <div class="rtier-row"><span class="rk">🚗 Car Note Assists</span><span class="rv2">9 families</span></div>
          <div class="rtier-row"><span class="rk">⛽ Gas Cards</span><span class="rv2">28 cards</span></div>
          <div class="rtier-row"><span class="rk">⚡ Electric Assists</span><span class="rv2">9 families</span></div>
          <div class="rtier-row"><span class="rk">🛒 Grocery Cards</span><span class="rv2">12 cards</span></div>
        </div>
      </div>
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.24">
        <div class="uc rtier h-100">
          <div class="rtier-head">$5.99/month</div>
          <div class="rtier-price">$44,925<span>/mo fund</span></div>
          <div class="rtier-fund">15% of $299,500 total</div>
          <div class="rtier-row"><span class="rk">🏠 Mortgage Assists</span><span class="rv2">8 families</span></div>
          <div class="rtier-row"><span class="rk">🚗 Car Note Assists</span><span class="rv2">22 families</span></div>
          <div class="rtier-row"><span class="rk">⛽ Gas Cards</span><span class="rv2">67 cards</span></div>
          <div class="rtier-row"><span class="rk">⚡ Electric Assists</span><span class="rv2">22 families</span></div>
          <div class="rtier-row"><span class="rk">🛒 Grocery Cards</span><span class="rv2">29 cards</span></div>
        </div>
      </div>
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.32">
        <div class="uc rtier h-100" style="border-color:rgba(0,212,255,.25);background:rgba(0,212,255,.05);">
          <div class="rtier-head">$19.99/month</div>
          <div class="rtier-price">$149,925<span>/mo fund</span></div>
          <div class="rtier-fund">15% of $999,500 total</div>
          <div class="rtier-row"><span class="rk">🏠 Mortgage Assists</span><span class="rv2">29 families</span></div>
          <div class="rtier-row"><span class="rk">🚗 Car Note Assists</span><span class="rv2">74 families</span></div>
          <div class="rtier-row"><span class="rk">⛽ Gas Cards</span><span class="rv2">224 cards</span></div>
          <div class="rtier-row"><span class="rk">⚡ Electric Assists</span><span class="rv2">74 families</span></div>
          <div class="rtier-row"><span class="rk">🛒 Grocery Cards</span><span class="rv2">99 cards</span></div>
        </div>
      </div>
    </div>

    <!-- 500K Residents -->
    <div class=" mb-3" sipScrollReveal [sipDelay]="0">
      <span class="lbl">👥 500,000 Residents</span>
    </div>
    <div class="row g-3 mb-5">
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.08">
        <div class="uc rtier h-100">
          <div class="rtier-head">$2.54/month</div>
          <div class="rtier-price">$190,500<span>/mo fund</span></div>
          <div class="rtier-fund">15% of $1,270,000 total</div>
          <div class="rtier-row"><span class="rk">🏠 Mortgage Assists</span><span class="rv2">38 families</span></div>
          <div class="rtier-row"><span class="rk">🚗 Car Note Assists</span><span class="rv2">95 families</span></div>
          <div class="rtier-row"><span class="rk">⛽ Gas Cards</span><span class="rv2">285 cards</span></div>
          <div class="rtier-row"><span class="rk">⚡ Electric Assists</span><span class="rv2">95 families</span></div>
          <div class="rtier-row"><span class="rk">🛒 Grocery Cards</span><span class="rv2">127 cards</span></div>
        </div>
      </div>
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.24">
        <div class="uc rtier h-100">
          <div class="rtier-head">$5.99/month</div>
          <div class="rtier-price">$449,250<span>/mo fund</span></div>
          <div class="rtier-fund">15% of $2,995,000 total</div>
          <div class="rtier-row"><span class="rk">🏠 Mortgage Assists</span><span class="rv2">89 families</span></div>
          <div class="rtier-row"><span class="rk">🚗 Car Note Assists</span><span class="rv2">224 families</span></div>
          <div class="rtier-row"><span class="rk">⛽ Gas Cards</span><span class="rv2">673 cards</span></div>
          <div class="rtier-row"><span class="rk">⚡ Electric Assists</span><span class="rv2">224 families</span></div>
          <div class="rtier-row"><span class="rk">🛒 Grocery Cards</span><span class="rv2">299 cards</span></div>
        </div>
      </div>
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.32">
        <div class="uc rtier h-100" style="border-color:rgba(0,212,255,.25);background:rgba(0,212,255,.05);">
          <div class="rtier-head">$19.99/month</div>
          <div class="rtier-price">$1.49M<span>/mo fund</span></div>
          <div class="rtier-fund">15% of $9,995,000 total</div>
          <div class="rtier-row"><span class="rk">🏠 Mortgage Assists</span><span class="rv2">299 families</span></div>
          <div class="rtier-row"><span class="rk">🚗 Car Note Assists</span><span class="rv2">749 families</span></div>
          <div class="rtier-row"><span class="rk">⛽ Gas Cards</span><span class="rv2">2,248 cards</span></div>
          <div class="rtier-row"><span class="rk">⚡ Electric Assists</span><span class="rv2">749 families</span></div>
          <div class="rtier-row"><span class="rk">🛒 Grocery Cards</span><span class="rv2">999 cards</span></div>
        </div>
      </div>
    </div>

    <!-- 5M Residents -->
    <div class=" mb-3" sipScrollReveal [sipDelay]="0">
      <span class="lbl">👥 5,000,000 Residents — Full DFW Scale</span>
    </div>
    <div class="row g-3">
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.08">
        <div class="uc rtier h-100">
          <div class="rtier-head">$2.54/month</div>
          <div class="rtier-price">$1.9M<span>/mo fund</span></div>
          <div class="rtier-fund">15% of $12,700,000 total</div>
          <div class="rtier-row"><span class="rk">🏠 Mortgage Assists</span><span class="rv2">381 families</span></div>
          <div class="rtier-row"><span class="rk">🚗 Car Note Assists</span><span class="rv2">952 families</span></div>
          <div class="rtier-row"><span class="rk">⛽ Gas Cards</span><span class="rv2">2,857 cards</span></div>
          <div class="rtier-row"><span class="rk">⚡ Electric Assists</span><span class="rv2">952 families</span></div>
          <div class="rtier-row"><span class="rk">🛒 Grocery Cards</span><span class="rv2">1,270 cards</span></div>
        </div>
      </div>
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.24">
        <div class="uc rtier h-100">
          <div class="rtier-head">$5.99/month</div>
          <div class="rtier-price">$4.49M<span>/mo fund</span></div>
          <div class="rtier-fund">15% of $29,950,000 total</div>
          <div class="rtier-row"><span class="rk">🏠 Mortgage Assists</span><span class="rv2">898 families</span></div>
          <div class="rtier-row"><span class="rk">🚗 Car Note Assists</span><span class="rv2">2,246 families</span></div>
          <div class="rtier-row"><span class="rk">⛽ Gas Cards</span><span class="rv2">6,738 cards</span></div>
          <div class="rtier-row"><span class="rk">⚡ Electric Assists</span><span class="rv2">2,246 families</span></div>
          <div class="rtier-row"><span class="rk">🛒 Grocery Cards</span><span class="rv2">2,995 cards</span></div>
        </div>
      </div>
      <div class="col-md-4" sipScrollReveal [sipDelay]="0.32">
        <div class="uc rtier h-100" style="border-color:rgba(0,212,255,.3);background:linear-gradient(135deg,rgba(0,212,255,.08),rgba(0,87,255,.05));box-shadow:0 0 50px rgba(0,212,255,.1);">
          <div class="rtier-head" style="color:var(--cc);">$19.99/month</div>
          <div class="rtier-price" style="font-size:2.4rem;">$14.99M<span>/mo fund</span></div>
          <div class="rtier-fund">15% of $99,950,000 total</div>
          <div class="rtier-row"><span class="rk">🏠 Mortgage Assists</span><span class="rv2">2,998 families</span></div>
          <div class="rtier-row"><span class="rk">🚗 Car Note Assists</span><span class="rv2">7,496 families</span></div>
          <div class="rtier-row"><span class="rk">⛽ Gas Cards</span><span class="rv2">22,488 cards</span></div>
          <div class="rtier-row"><span class="rk">⚡ Electric Assists</span><span class="rv2">7,496 families</span></div>
          <div class="rtier-row"><span class="rk">🛒 Grocery Cards</span><span class="rv2">9,995 cards</span></div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════════════ PERSPECTIVE ════════════════ -->
<section class="usec">
  <div class="cg"></div>
  <div class="container" style="position:relative;z-index:1;">
    <div class="row g-5 align-items-center">
      <div class="col-lg-5 " sipScrollReveal [sipDelay]="0">
        <span class="lbl">🚨 Combined Perspective</span>
        <h2 class="hd2 mb-4">Nearly <span class="ac">$9 Million</span><br>Per Year</h2>
        <p class="tx mb-3">That's the annual circulation potential at 100,000 business participation — and that's <strong style="color:var(--cw);">only businesses</strong>, not residents.</p>
        <p class="tx mb-4">When resident revenue is combined, the total economic stimulus becomes a multi-million dollar monthly engine — entirely community-owned, entirely DFW-controlled.</p>
        <div class="qcard">
          <p>"When the community owns it, the community can protect it. Ownership creates protection. Circulation creates stability. Unity creates strength."</p>
        </div>
      </div>
      <div class="col-lg-7 " sipScrollReveal [sipDelay]="0.08">
        <div class="row g-3">
          <div class="col-md-4 text-center">
            <div class="uc p-3">
              <div class="vision-num">$262K</div>
              <div style="font-size:.76rem;letter-spacing:.12em;text-transform:uppercase;color:var(--cm);margin-top:.5rem;">Monthly at 35K Businesses</div>
            </div>
          </div>
          <div class="col-md-4 text-center">
            <div class="uc p-3" style="border-color:rgba(0,212,255,.3);background:rgba(0,212,255,.05);">
              <div class="vision-num">$374K</div>
              <div style="font-size:.76rem;letter-spacing:.12em;text-transform:uppercase;color:var(--cm);margin-top:.5rem;">Monthly at 50K Businesses</div>
            </div>
          </div>
          <div class="col-md-4 text-center">
            <div class="uc p-3">
              <div class="vision-num">$749K</div>
              <div style="font-size:.76rem;letter-spacing:.12em;text-transform:uppercase;color:var(--cm);margin-top:.5rem;">Monthly at 100K Businesses</div>
            </div>
          </div>
          <div class="col-12">
            <div style="background:linear-gradient(135deg,rgba(0,212,255,.07),rgba(0,87,255,.05));border:1px solid rgba(0,212,255,.2);border-radius:14px;padding:2rem;text-align:center;">
              <div style="font-family:var(--fh);font-size:clamp(2rem,5vw,4rem);color:var(--cc);text-shadow:0 0 30px rgba(0,212,255,.4);line-height:1;">~$9 MILLION</div>
              <div style="font-size:.8rem;letter-spacing:.15em;text-transform:uppercase;color:var(--cm);margin-top:.5rem;">Per Year Circulating Back Into DFW</div>
              <div style="font-size:.75rem;color:rgba(94,232,255,.6);margin-top:.3rem;">At 100K Business Participation · Businesses Only</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════════════ VISION ════════════════ -->
<section class="usec usec-alt">
  <div class="container">
    <div class="text-center mb-5 " sipScrollReveal [sipDelay]="0">
      <span class="lbl">The National Blueprint</span>
      <h2 class="hd2">DFW Becomes <span class="ac">The Example</span></h2>
      <div class="dv mx-auto"></div>
    </div>
    <div class="row g-4">
      <div class="col-md-6 col-lg-3 " sipScrollReveal [sipDelay]="0.08">
        <div class="uc p-3 text-center h-100">
          <div style="font-size:2.5rem;margin-bottom:.8rem;">🛡️</div>
          <h6 style="font-family:var(--fh);font-size:1.2rem;letter-spacing:.05em;color:var(--cw);">Youth Are Protected</h6>
          <p style="font-size:.84rem;color:var(--cm);margin:0;">Anti-bullying training, self-defense, and mental wellness for DFW students.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 " sipScrollReveal [sipDelay]="0.24">
        <div class="uc p-3 text-center h-100">
          <div style="font-size:2.5rem;margin-bottom:.8rem;">🧠</div>
          <h6 style="font-family:var(--fh);font-size:1.2rem;letter-spacing:.05em;color:var(--cw);">Mental Health Prioritized</h6>
          <p style="font-size:.84rem;color:var(--cm);margin:0;">Coaching, behavioral support, and structured wellness programs for all ages.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 " sipScrollReveal [sipDelay]="0.32">
        <div class="uc p-3 text-center h-100">
          <div style="font-size:2.5rem;margin-bottom:.8rem;">📈</div>
          <h6 style="font-family:var(--fh);font-size:1.2rem;letter-spacing:.05em;color:var(--cw);">Businesses Elevated</h6>
          <p style="font-size:.84rem;color:var(--cm);margin:0;">Hyper-local marketplace, digital exposure, and community-backed brand growth.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 " sipScrollReveal [sipDelay]="0.4">
        <div class="uc p-3 text-center h-100">
          <div style="font-size:2.5rem;margin-bottom:.8rem;">🏘️</div>
          <h6 style="font-family:var(--fh);font-size:1.2rem;letter-spacing:.05em;color:var(--cw);">No One Invisible</h6>
          <p style="font-size:.84rem;color:var(--cm);margin:0;">Every resident supported. Dollars stay local. Community circulates inward.</p>
        </div>
      </div>
    </div>
    <div class=" mt-5 text-center" sipScrollReveal [sipDelay]="0">
      <p class="tx mx-auto" style="max-width:680px;font-size:1.05rem;">When other cities see what happens here — when they see a community funding its own protection, its own healing, its own expansion — they won't ask if it's possible.</p>
      <p style="font-family:var(--fh);font-size:clamp(1.5rem,4vw,2.5rem);color:var(--cc);letter-spacing:.05em;text-shadow:0 0 20px rgba(0,212,255,.3);margin-top:1rem;">They Will Demand It In Their City.</p>
    </div>
  </div>
</section>

<!-- ════════════════ FINAL CTA ════════════════ -->
<section class="ucta">
  <div class="uctag"></div>
  <div class="container" style="position:relative;z-index:1;">
    <div class="" sipScrollReveal [sipDelay]="0">
      <span class="lbl d-block text-center mb-3">Join the Movement Today</span>
      <h2>This Is Not Charity.<br><span>This Is Power Organized.</span></h2>
      <p class="tx mx-auto mt-4 mb-4" style="max-width:580px;font-size:1rem;">
        When Dallas protects its students, Fort Worth protects its future.<br>
        When businesses reinvest locally, neighborhoods stabilize.<br>
        When community unites, bullying loses power.
      </p>
      <div class="d-flex flex-wrap gap-3 justify-content-center">
        <a href="/#registration-form" class="btn-c">👉 Join Now</a>
        <a href="/#partner" class="btn-o">Partner With Us</a>
      </div>
      <p style="margin-top:1.5rem;font-size:.82rem;color:var(--cm);">Membership starts at just <strong style="color:var(--ccl);">$2.54/month</strong></p>
    </div>
  </div>
</section>

<!-- ════════ FOOTER ════════ -->
<footer class="ufoot">
  <div class="container">
    <img src="assetses/img/logo.png" alt="UMYOBizDFW" onerror="this.style.display='none'">
    <div class="ufb">UMYOBizDFW</div>
    <p>DFW's First Privacy-Gated Digital Community</p>
    <div class="d-flex justify-content-center gap-4 flex-wrap">
      <a href="/">Home</a>
      <a href="/about">About Us</a>
      <a routerLink="/networks">Network</a>
      <a routerLink="/hub">Hub</a>
      <a routerLink="/anti-bullying">Anti-Bullying</a>
      <a routerLink="/community-impact">Community Fund</a>
      <a routerLink="/empower-youth">Empower Youth</a>
      <a routerLink="/services">Type of Servcies</a>
      <a routerLink="/cf">Card Features</a>
      <a href="/terms">Terms &amp; Conditions</a>
    </div>
    <p class="ufc2">© 2025 UMYOBizDFW · Built by the community, for the community</p>
  </div>
</footer>